<div class="resumen">
  <div class="resumen__row resumen__row--base">
    <!-- #4893 — the resumen is read next to the paper invoice, which carries only the provider's fiscal
         number; the shared identity puts that first and keeps ours underneath. Not clickable: the resumen
         is embedded in screens that are already about this document. -->
    <span class="resumen__doc">
      <app-document-identity [documentNumber]="payable.document.number" [fiscalNumber]="payable.document.fiscalNumber" [clickable]="false" />
    </span>
    <span class="tabular-nums">{{ payable.document.totalAmount | number: '1.2-2' }} {{ currencyLabel }}</span>
  </div>

  @if ((payable.document.paidAmount ?? 0) > 0) {
    <div class="resumen__row resumen__row--muted">
      <span>{{ 'ApDocument_AlreadyPaid' | translateWF: 'Already paid' }}</span>
      <span class="tabular-nums">− {{ payable.document.paidAmount | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  }

  <!-- Withholding is what reduced the payable BEFORE anyone paid it, so the certificate responsible is named
       the same way the notes below are — one row each, by number. The bare total is kept only for a document
       withheld before the certificates were recorded per source, where there is nothing to name. -->
  @for (retention of payable.withholdings; track retention.reference) {
    <div class="resumen__row resumen__row--muted">
      <span>
        {{ 'ApDocument_Withholding' | translateWF: 'Withholding (Retención)' }}
        {{ retention.certificateNumber || retention.number }}
        @if (retention.issuedDate) {
          <span class="resumen__aside">· {{ retention.issuedDate | date: 'dd/MM/yyyy' }}</span>
        }
        @if (retention.remittanceNumber) {
          <!-- Filed with SAR. Informational: the payable was reduced when the certificate posted, not when
               the remittance paid, so this never changes what is owed here. -->
          <span class="resumen__aside">· {{ 'WithholdingRemittance_Short' | translateWF: 'remitted' }} {{ retention.remittanceNumber }}</span>
        }
      </span>
      <span class="tabular-nums">− {{ retention.withheldAmount | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  } @empty {
    @if (payable.withheldAmount > 0) {
      <div class="resumen__row resumen__row--muted">
        <span>{{ 'ApDocument_Withholding' | translateWF: 'Withholding (Retención)' }}</span>
        <span class="tabular-nums">− {{ payable.withheldAmount | number: '1.2-2' }} {{ currencyLabel }}</span>
      </div>
    }
  }

  @for (dn of payable.debitNotes; track dn.id) {
    <div class="resumen__row">
      <span>{{ 'ApDocument_DebitNote' | translateWF: 'Debit note' }} {{ dn.number }}</span>
      <span class="tabular-nums">+ {{ noteAmount(dn.balanceDue, dn.totalAmount) | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  }

  <!-- #6324 — what each credit note took off this document when it posted. Whatever this document could not
       absorb is the provider's open credit, shown beside it but not part of this net. -->
  @for (cn of payable.creditNotes; track cn.id) {
    <div class="resumen__row resumen__row--credit">
      <span>
        {{ 'ApDocument_CreditNote' | translateWF: 'Credit note' }} {{ cn.number }}
        @if ((cn.balanceDue ?? 0) > 0) {
          <span class="resumen__aside">· {{ 'ApDocument_Note_ProviderCredit' | translateWF: 'Left as provider credit' }} {{ cn.balanceDue | number: '1.2-2' }}</span>
        }
      </span>
      <span class="tabular-nums">− {{ cn.creditAppliedAmount ?? 0 | number: '1.2-2' }} {{ currencyLabel }}</span>
    </div>
  }

  <div class="resumen__row resumen__row--net">
    <span>{{ 'ApDocument_NetToPay' | translateWF: 'Net payable' }}</span>
    <span class="tabular-nums">{{ payable.netPayable | number: '1.2-2' }} {{ currencyLabel }}</span>
  </div>

  @if (advances().length > 0) {
    <div class="resumen__advances">
      <div class="resumen__row resumen__advances-title">
        <span>{{ 'ApDocument_AdvancesForPo' | translateWF: 'Advances against the PO' }}</span>
        <span class="tabular-nums">{{ advancesTotal() | number: '1.2-2' }} {{ currencyLabel }}</span>
      </div>
      @for (advance of advances(); track advance.advanceNumber + advance.purchaseOrderNumber) {
        <div class="resumen__row resumen__row--muted">
          <span>{{ advance.advanceNumber }} · {{ 'PurchaseOrder_Short' | translateWF: 'PO' }} {{ advance.purchaseOrderNumber }}</span>
          <span class="tabular-nums">{{ advance.allocatedAmount | number: '1.2-2' }} {{ currencyLabel }}</span>
        </div>
      }
      <p class="resumen__hint">
        {{ 'ApDocument_AdvancesHint' | translateWF: 'Anticipos already paid against this PO — informational; apply them when settling.' }}
      </p>
    </div>
  }
</div>
